import service from "@/utils/requests";

const base_url_mobile = 'https://mobile.kan0512.com/'

const API = {
  wxshare_api: base_url_mobile + 'wxshare/api.php'
}
// 获取微信分享参数
export function GetWxParams(query) {
  return service({
    url: API.wxshare_api,
    method: 'get',
    params: query
  })
}

// 用户登陆接口
export function userLogin(data) {
    return service.post('/api/login',data)
}
// 用户注册接口
export function userRegister(data) {
    return service.post('/api/register',data)
}
// 更新用户信息接口
export function getUserInfo(data) {
  return service.post('/api/user/info',data)
}
// 获取用户健康档案信息接口
export function getUserHealth(data) {
  return service.post('/api/user/health',data)
}
// 编辑用户健康档案接口
export function EditUserHealth(data) {
  return service.post('/api/user/health_edit',data)
}
// 用户退出接口
export function userLogout(data) {
  return service.post('/api/logout',data)
}
export function LoseWeight(data) {
  return service.post('/api/user/weight',data)
}
export function recordList(data) {
  return service.post('/api/record/tg/list',data)
}
export function recordEdit(data) {
  return service.post('/api/record/tg/edit',data)
}
export function recordDetails(data) {
  return service.post('/api/record/diet/details',data)
}

export function foodList(data) {
  return service.post('/api/record/diet/list',data)
}

export function shiwubiao(data) {
  return service.post('/api/record/diet/food',data)
}

export function sumbit(data) {
  return service.post('/api/record/diet/edit',data)
}

export function GetEatDetail(data) {
  return service.post('/api/record/diet/eat',data)
}

export function delEatDetail(data) {
  return service.post('/api/record/diet/del',data)
}

export function dietDrink(data) {
  return service.post('/api/record/diet/water',data)
}
// 运动耗能+搜索
export function getSportsList(data) {
  return service.post('/api/record/sport/calorie',data)
}
// 运动列表 补日期
export function sportDateList(data) {
  return service.post('/api/record/sport/list',data)
}
// 添加运动记录
export function addSportRecord(data) {
  return service.post('/api/record/sport/edit',data)
}
// 运动当日详情
export function getDaySportDetail(data) {
  return service.post('/api/record/sport/details',data)
}
// 删除运动记录
export function delSportDetail(data) {
  return service.post('/api/record/sport/del',data)
}
// 发送手机号
export function sendMobile(data) {
  return service.post('api/send',data)
}
// 发送手机号
export function dietList(data) {
  return service.post('api/record/diet/daily',data)
}
// 我的消息列表
export function message(params) {
  return service({
    url:'/api/message',
    method: 'get',
    params
  })
}
// 忘记密码（获取验证码）
export function wjpwdsms(data) {
  return service({
    url:'/api/user/wjpwdsms',
    method: 'post',
    data
  })
}
// 忘记密码（校验验证码）
export function wjpwd1(data) {
  return service({
    url:'/api/user/wjpwd1',
    method: 'post',
    data
  })
}
// 重设密码
export function wjpwd2(data) {
  return service({
    url:'/api/user/wjpwd2',
    method: 'post',
    data
  })
}
// 阅读消息
export function read(data) {
  return service({
    url:'/api/message/read',
    method: 'post',
    data
  })
}
// 我的减重方案（列表）
export function weightList(params) {
  return service({
    url:'/api/weight/index',
    method: 'get',
    params
  })
}
// 我的减重方案（详情）
export function weightDetail(params) {
  return service({
    url:'/api/weight/detail',
    method: 'get',
    params
  })
}

// 我的饮食记录（列表）
export function yinshi(params) {
  return service({
    url:'/api/yinshi',
    method: 'get',
    params
  })
}
// 我的饮食记录-删除
export function delYinshi(data) {
  return service({
    url:'/api/record/diet/del',
    method: 'post',
    data
  })
}
// 我的饮食记录（曲线）
export function yinshiQX(params) {
  return service({
    url:'/api/yinshi/qx',
    method: 'get',
    params
  })
}
// 我的体格记录（曲线）
export function tgqx(params) {
  return service({
    url:'/api/record/tgqx',
    method: 'get',
    params
  })
}
// 我的运动记录（曲线）
export function ydqx(params) {
  return service({
    url:'/api/record/ydqx',
    method: 'get',
    params
  })
}
// 我的运动记录-删除
export function delSport(data) {
  return service({
    url:'/api/record/sport/del',
    method: 'post',
    data
  })
}
// 我的检查列表
export function checklist(params) {
  return service({
    url:'/api/checklist',
    method: 'get',
    params
  })
}
// 我的检查列表
export function checkDetail(params) {
  return service({
    url:'/api/checklist/detail',
    method: 'get',
    params
  })
}
// 我的睡眠（曲线）
export function sleepQx(params) {
  return service({
    url:'/api/sleep/qx',
    method: 'get',
    params
  })
}
// 我的睡眠（列表））
export function sleepList(params) {
  return service({
    url:'/api/sleep',
    method: 'get',
    params
  })
}
// 我的睡眠（保存）
export function saveSleep(data) {
  return service({
    url:'/api/sleep/save',
    method: 'post',
    data
  })
}
// 我的睡眠（计算）
export function jisuanSleep(data) {
  return service({
    url:'/api/sleep/jisuan',
    method: 'post',
    data
  })
}